import FornecedorEnderecoService from "@/services/FornecedorEnderecoService";

export const fornecedorEndereco = {
  namespaced: true,
  state: {
    fornecedorEndereco: {},
  },
  actions: {
    getFornecedorEndereco({ commit }, payload) {
      return FornecedorEnderecoService.GetFornecedorEndereco(payload).then(
        (fornecedorEndereco) => {
          return Promise.resolve(fornecedorEndereco);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    postFornecedorEndereco({ commit }, payload) {
      return FornecedorEnderecoService.PostFornecedorEndereco(payload).then(
        (fornecedorEndereco) => {
          return Promise.resolve(fornecedorEndereco);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    putFornecedorEndereco({ commit }, payload) {
      return FornecedorEnderecoService.PutFornecedorEndereco(payload).then(
        (fornecedorEndereco) => {
          return Promise.resolve(fornecedorEndereco);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    deleteFornecedorEndereco({ commit }, payload) {
      return FornecedorEnderecoService.DeleteFornecedorEndereco(payload).then(
        (response) => {
          return Promise.resolve(response);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    getFornecedorEnderecoOData({ commit }, payload) {
      return FornecedorEnderecoService.GetFornecedorEnderecoOData(payload).then(
        (fornecedorEndereco) => {
          return Promise.resolve(fornecedorEndereco);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
  },
  mutations: {},
};

export default fornecedorEndereco;
